export default function($element, moduleName, setup = null) {
    if (setup) {
        if (setup.config) {
            return setup.config();
        }

        if (setup.configs) {
            return setup.configs[moduleName] ? setup.configs[moduleName]() : null;
        }
    }

    if ($element.dataset.config) {
        return JSON.parse($element.dataset.config);
    }

    if ($element.dataset.configs) {
        const parsedConfigs = JSON.parse($element.dataset.configs);
        return parsedConfigs[moduleName] || null;
    }

    return null;
}